








































































import { computed, defineComponent, toRefs, ref } from '@vue/composition-api';
import QuotaDetailsContainer from '../quota-detail-container/index.vue';
import QuotaStepInfo from '../quota-step-info/index.vue';
import StepLegend from '../step-legend/index.vue';
import { PropType } from 'vue';
import { Ios14Quota } from '@tt4b/ttam-enums';
import AppleIcon from '@tt4b/ttam-assets/src/svgs/apple.svg';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-ios14-info-quota-detail-campaign';
export default defineComponent({
  name,
  components: { AppleIcon, StepLegend, QuotaStepInfo, QuotaDetailsContainer, ALink },
  props: {
    ios14Quota: {
      type: Object as PropType<Ios14Quota>,
    },
    eventManagerUrl: {
      type: String,
    },
    appName: {
      type: String,
    },
    isOnlySupportTiktok: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { ios14Quota, isOnlySupportTiktok } = toRefs(props);
    const isSplitTestEnabled = ref(false);

    const tikTokQuotaUsed = computed(() => ios14Quota.value.campaignQuota?.tikTokQuotaUsed || 0);
    const tikTokQuotaTotal = computed(() => ios14Quota.value.campaignQuota?.tikTokQuotaTotal || 0);
    const tikTokReleasing = computed(() => ios14Quota.value.campaignQuota?.tikTokQuotaReleasing || 0);
    const remainCampaignTikTokQuota = computed(() => ios14Quota.value.campaignQuota?.tikTokQuotaAvailable || 0);
    const remainCampaignPangleQuota = computed(() => ios14Quota.value.campaignQuota?.pangleQuota || 0);
    const shouldShowDcQuotaByTiktok = computed(() => isOnlySupportTiktok.value && ios14Quota.value.isAppIdInWhitelist);

    const quotaUsed = computed(() => {
      const quotaUsedNum = ios14Quota.value.campaignQuota?.usedQuota || 0;
      if (shouldShowDcQuotaByTiktok.value) {
        return tikTokQuotaUsed.value;
      }
      return quotaUsedNum;
    });
    const quotaTotal = computed(() => {
      const quotaTotalNum = ios14Quota.value.campaignQuota?.totalQuota || 0;
      if (shouldShowDcQuotaByTiktok.value) {
        return tikTokQuotaTotal.value;
      }
      return quotaTotalNum;
    });
    const quotaReleasing = computed(() => {
      const quotaReleasingNum = ios14Quota.value.campaignQuota?.releasingQuota || 0;
      if (shouldShowDcQuotaByTiktok.value) {
        return tikTokReleasing.value;
      }
      return quotaReleasingNum;
    });
    const quotaRemain = computed(() => {
      const quotaRemainNum = ios14Quota.value.campaignQuota?.availableQuota || 0;
      if (shouldShowDcQuotaByTiktok.value) {
        return remainCampaignTikTokQuota.value;
      }
      return quotaRemainNum;
    });
    const legends = computed(() => {
      let arr: string[] = [];
      if (quotaUsed.value > 0) {
        arr.push('used');
      }
      if (quotaReleasing.value > 0) {
        arr.push('reset');
      }
      arr.push('unused');

      return arr;
    });

    const isShowQuotaInfoByInventory = computed(
      () => !isOnlySupportTiktok.value && ios14Quota.value.isAppIdInWhitelist,
    );
    return {
      name,
      legends,
      quotaUsed,
      quotaTotal,
      quotaRemain,
      quotaReleasing,
      isSplitTestEnabled,
      tikTokQuotaUsed,
      tikTokQuotaTotal,
      tikTokReleasing,
      shouldShowDcQuotaByTiktok,
      remainCampaignTikTokQuota,
      remainCampaignPangleQuota,
      isShowQuotaInfoByInventory,
    };
  },
});
